export class CommunicationTokenReplaceModel {
	subject: string;
	body: string;
}
